export default __webpack_public_path__ + "static/media/Megan_9781408335666.16273b68.jpg";